// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CurrencyController from "./currency_controller"
application.register("currency", CurrencyController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PickerController from "./picker_controller"
application.register("picker", PickerController)

import ScrollHeaderController from "./scroll_header_controller"
application.register("scroll-header", ScrollHeaderController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
